/* eslint-disable react/no-unused-state */

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Panel from '../../../components/panel';
import styles from './GateAllocations.module.scss';
import { renderInfoForType } from '../../../utils/helpers';
import Clickable from '../../../components/clickable/Clickable';
import CloseIcon from '../../../icons/close_dark.svg';

class RequestDetailModal extends Component {
  state = {
    loadingStatus: false,
    modal: false,
    ActionDropdown: false
  };

  render() {
    const { gateRequest, onClose } = this.props;

    const arrivalTypes = {
      domestic: 'Domestic',
      international: 'International'
    };

    let fields = [];

    if (gateRequest) {
      fields = [
        {
          id: 'gate.new.reported_by',
          default_message: 'Requested by',
          value: gateRequest?.logged_by?.fullname
        },
        {
          id: 'gate.new.submission_date',
          default_message: 'Requested Date',
          value: renderInfoForType({ type: 'datetime' }, gateRequest.requested_date)
        },
        {
          id: 'gate.form.airline',
          default_message: 'Airline',
          value: gateRequest.airline
        },
        {
          id: 'gate.form.flight_no',
          default_message: 'Flight #',
          value: gateRequest.flight_number
        },
        {
          id: 'gate.form.depart_airport',
          default_message: 'Departure Airport',
          value: gateRequest.dept_airport
        },
        {
          id: 'gate.form.arrival_time',
          default_message: 'Arrival Date',
          value: renderInfoForType({ type: 'datetime' }, gateRequest.arrival_date)
        },
        {
          id: 'gate.form.aircraft',
          default_message: 'Aircraft',
          value: gateRequest?.aircraft
        },
        {
          id: 'gate.form.arrival_type',
          default_message: 'Arrival Type',
          value: arrivalTypes?.[gateRequest.arrival_type]
        },
        {
          id: 'gate.form.in_date',
          default_message: 'Requested In-Block Time',
          value: renderInfoForType({ type: 'datetime' }, gateRequest.in_date)
        },
        {
          id: 'gate.form.off_date',
          default_message: 'Requested Off-Block Time',
          value: renderInfoForType({ type: 'datetime' }, gateRequest.from_date)
        },
        {
          id: 'gate.form.remarks',
          default_message: 'Remarks',
          value: gateRequest.remarks,
          fullWidth: true
        }
      ];

      if (gateRequest?.to_gate) {
        fields.push({
          id: 'gate.form.requested_gate',
          default_message: 'Requested Gate',
          value: gateRequest?.to_gate,
          fullWidth: true
        });
      }

      if (gateRequest?.info?.rejected?.comment) {
        fields.push({
          id: 'gate.form.rejected_comments',
          default_message: 'Reason for Rejected',
          value: gateRequest?.info?.rejected?.comment,
          fullWidth: true
        });
      }
    }

    return (
      <>
        <div style={{ position: 'absolute', top: '15px', right: '25px' }}>
          <Clickable onClick={onClose} className={styles.closeIcon}>
            <img src={CloseIcon} alt="closeIcon" />
          </Clickable>
        </div>

        <Panel
          containerClasses={styles.mainPanel}
          title="gateRequest.detail"
          defaultTitle="Gate Change Request Details"
        >
          {gateRequest && (
            <div className={styles.panelContent}>
              <div className={styles.stepInfo} style={{ marginTop: '10px' }}>
                {fields.map(field => (
                  <div
                    key={field.id}
                    className={field.fullWidth ? styles.infoFull : styles.infoHalf}
                  >
                    <span className={styles.title}>
                      <FormattedMessage
                        id={field.id}
                        defaultMessage={field.default_message}
                      />
                    </span>
                    <p className={styles.rowContent}>{field.value}</p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Panel>
      </>
    );
  }
}

export default RequestDetailModal;
